import React, { useState } from 'react';
import { Button, Container, Col, Form, Row } from 'react-bootstrap';
import Logo from '../../img/logo-ahrq.png';

const Header = () => {  
 
    const [searchText, setSearchText] = useState('');
    const [searchOption, setSearchOption] = useState('AHRQ_QI');
    const handleSubmit = (e) => {
        e.preventDefault();
        chooseSearch(searchText, searchOption);
    }

    function chooseSearch(text, option) {
        if (option === "AHRQ") {
            doSearch();
        }
        else {
            routeToGoogle(text);
        }
    }
    
    function routeToGoogle(text) {
        var sendLoc = "https://search.ahrq.gov/search?q=" + text + "&siteDomain=qualityindicators.ahrq.gov";        
        window.open(sendLoc, '_blank');
    }
    
    function doSearch(key) {                       
        document.getElementById('searchForm').submit();        
    }

    return (<>
        <Container fluid className="top-header">
            <div>
                <img src="/images/us_flag_small.png" />
                <img src="/images/logo-HHSmini.png" />
                <h6><a href="https://www.hhs.gov/">An official website of the Department of Health & Human Services</a></h6>
            </div>
        </Container>
        <Container fluid className="utility-nav">
            <ul>
                <li><a href="https://www.ahrq.gov/cpi/about/careers/index.html">Careers</a></li>
                <li><a href="https://www.ahrq.gov/contact/index.html">Contact Us</a></li>
                <li><a href="https://www.ahrq.gov/topics/informacion-en-espanol/index.html">Español</a></li>
                <li><a href="https://info.ahrq.gov/">FAQs</a></li>
                <li><a href="https://subscriptions.ahrq.gov/accounts/USAHRQ/subscriber/new"><img src="/images/envelope-regular.png" />Email Updates</a></li>
            </ul>
        </Container>
        <Container fluid className="header-logo-container">
            <Form id="searchForm" target="_blank" action="http://search.ahrq.gov/search">
                <input type="hidden" name="q" value={searchText}></input>
                <input type="hidden" name="entqr" value="0"></input>
                <input type="hidden" name="output" value="xml_no_dtd"></input>
                <input type="hidden" name="proxystylesheet" value="AHRQ_GOV"></input>
                <input type="hidden" name="client" value="AHRQ_GOV"></input>
                <input type="hidden" name="site" value="default_collecti</Input>on"></input>
            </Form>

            <Row>
                <Col xs={12} md={4} className="header-logo">
                    <a href="https://www.ahrq.gov/"><img alt="ARHQ Logo" src={Logo} /></a>
                </Col>
                <Col xs={12} md={8} className={'header-search'} >
                  
                    <Form className='flex' onSubmit={e => { handleSubmit(e) }}>
                        <Form.Group className='flex' controlId="formBasicEmail">
                            <select className="selectOption" 
                            aria-label="Select" 
                            name='searchOption'
                            onChange={(e)=>setSearchOption(e.target.value)} >
                                <option selected value="AHRQ_QI">AHRQ QI</option>
                                <option value="AHRQ">AHRQ</option>
                            </select>
                            <Form.Control
                                className="search-form"
                                type="search"
                                placeholder="Search..."
                                name="searchText"       
                                onChange={(e)=>setSearchText(e.target.value)}                       
                            />
                            <Button className="search-btn" variant="primary" type="submit">
                                <i class="fa fa-search"></i>
                            </Button>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </Container>
    </>
    )
}

export default Header;